import moment from 'moment';

class InMemoryCache {
  constructor() {
    this.cache = {};
    this.expire = {};
  }

  get(key) {
    const expirationTime = this.expire[key];
    if (expirationTime && moment(expirationTime).isSameOrAfter(moment())) {
      return this.cache[key];
    }
    return null;
  }

  set(key, value, ttlInSeconds) {
    this.cache[key] = value;
    this.expire[key] = moment().add(ttlInSeconds, 'seconds').format();
  }

  delete(key) {
    delete this.cache[key];
    delete this.expire[key];
  }

  clear() {
    this.cache = {};
    this.expire = {};
  }
}

const cache = new InMemoryCache();

export { cache as InMemoryCache };
